document.querySelectorAll('[data-reel-motion]').forEach((wrapper) => {
  const video = wrapper.querySelector('video');
  const button = wrapper.querySelector('button');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = reduced.matches;
  // Keep the MP4 URL inactive until this reel is actually visible.
  const play = () => {
    const source = video.querySelector('source[data-src]');
    if (source && !source.hasAttribute('src')) {
      source.src = source.dataset.src;
      video.load();
    }
    video.play().catch(update);
  };
  const update = () => {
    const label = video.paused ? 'Play reel animation' : 'Pause reel animation';
    button.textContent = video.paused ? 'Play animation' : 'Pause animation';
    button.setAttribute('aria-label', label);
  };
  button.addEventListener('click', () => {
    userPaused = !video.paused;
    if (userPaused) video.pause(); else play();
  });
  video.addEventListener('play', update);
  video.addEventListener('pause', update);
  new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && !userPaused) play();
    else video.pause();
  }, { threshold: 0.15 }).observe(video);
  reduced.addEventListener('change', () => { if (reduced.matches) { userPaused = true; video.pause(); } });
});
